// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"99":"LazyGoogleOneTap","873":"LazyIdentificationForm"}[chunkId] + "." + {"99":"e288487cdf0112ffb4b3","873":"3225b085c6a3efc3ad88"}[chunkId] + ".js";
};